var _image;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "close-circle",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIISURBVHgB3VVLUsJAEO2JF9AbTAWscoknsDkB3EA8gXgCcOkKPAFwAr0Bs3SJaxVyAsGtpYnd84mTTAKUVS60qyaf6Zf3ZqY/AfjrJnYiGtil6zmNFg1pZxMaCxr38KJmPxMwxCOPtNoyEhMwrBOKKj9q4pCud5ZcEUkf0kgSidDjE05p7kLvRGjMFGIcwV7G5A3M9Ijxcic+xh5h1/abSdktArCAid3bKTypBexjx9iCFOb0dEg7u4KlGjtXVJIb6HtGZ+rIm9gHiTIglXiofWyMZWLHwb5AwARV6qAt1XVOnlGgI1qdL8IEPMe+2Ios1RQ4XryLSGddsIOOXcEwn/mg4GWUjhxIJ+LIBaUtLyalVHWWwcxydEOBTOc5UIY85nOJ2hBBuyBSJG8TJsnxqd4BWysUEIUiglqROnKDde8VMfgl8wU29i4LiPKZl2Pi20n+vqkSUHbmrJacj6UcE1/kHdA+LUIBAa6X9L39dYMzDwPf8Thcek6h0hq4si3iW4TbRV2hNfDcw/Xstyu/0IqtoolIK5tbTxuelYJ9zG8VAD2/sx4UgK9JAkeSyVEDj+QbrJOHreSm2idg+tCYKvrGd1f/D2Ic5BXt+n1EBej6Ex8Zn72pWLQ4Jr8qU9X/cExn5eYnYbttdHNcqtsq5+5fphHqEImpYmMJcCpmlNopZR9n1r+1L0OA1b084dA4AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.33174286.svg";
export { ForwardRef as ReactComponent };